/**
 * Single source of truth for the active book promotion.
 * After May 13, 2026, set `enabled` to false (or just leave it — the date
 * window auto-disables the promo regardless).
 */
export const PROMO = {
  enabled: true,
  // Promo runs May 9 → end of May 13 (Pacific time, ~UTC-7)
  // Using UTC-7 boundaries so the banner shows correctly across US time zones.
  startISO: '2026-05-09T07:00:00Z', // 12:00 AM PT May 9
  endISO:   '2026-05-14T07:00:00Z', // 12:00 AM PT May 14 (exclusive)

  // Display copy
  shortLabel: 'May 9 – May 13',
  longLabel: 'May 9–13, 2026',
  headline: 'FREE on Amazon · 5 Days Only',
  subline: 'Download F.U.C.K. T.H.A.T.T. — yours free until May 13',

  amazonUrl: 'https://www.amazon.com/dp/B0GZN2ZZ5V',
};

export function isPromoActive() {
  if (!PROMO.enabled) return false;
  const now = Date.now();
  const start = new Date(PROMO.startISO).getTime();
  const end = new Date(PROMO.endISO).getTime();
  return now >= start && now < end;
}

/**
 * Returns "X days, Y hours" remaining string, or null if not active.
 */
export function timeRemaining() {
  const end = new Date(PROMO.endISO).getTime();
  const ms = end - Date.now();
  if (ms <= 0) return null;
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  if (days >= 1) return `${days}d ${hours}h left`;
  const mins = Math.floor((ms % 3600000) / 60000);
  return `${hours}h ${mins}m left`;
}
